import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import styles from './styles.module.scss';

export interface IBoxIndicator {
  indicator: number;
  decimal?: number;
  percentPoint?: boolean;
  /** Cola o "%" no número ("2,2%"). O "pp" mantém o espaço. Padrão: false ("2,2 %"). */
  compactPercent?: boolean;
}

export const BoxIndicator = ({ indicator, decimal = 2, percentPoint, compactPercent = false }: IBoxIndicator) => {
  if (indicator === 0) {
    return null;
  }
  const formattedValue = Number(indicator).toFixed(decimal).replace('.', ',').replace('-', '');
  const suffix = percentPoint ? ' pp' : `${compactPercent ? '' : ' '}%`;
  return (
    <div className={styles['indicator-wrapper']}>
      {indicator > 0 ? <ArrowUpwardIcon className={styles['positive-icon']} /> : <ArrowDownwardIcon className={styles['negative-icon']} />}
      <p className={styles[indicator > 0 ? 'positive' : 'negative']}>{`${formattedValue}${suffix}`}</p>
    </div>
  );
};
